const TokenKey = 'PIECloud-Token'

export function getToken() {
  return window.localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return window.localStorage.setItem(TokenKey, token)
}
// 本地开发

export function removeToken() {
  return window.localStorage.removeItem(TokenKey)
}

const UserName = "user";
const roleName = "roleName"
const UserID = "userId";
export function getUser() {
  return window.localStorage.getItem(UserName)
}

export function setUser(user) {
  return window.localStorage.setItem(UserName, user)
}

export function removeUser() {
  return window.localStorage.removeItem(UserName)
}

export function getRoleName() {
  return window.localStorage.getItem(roleName)
}

export function setRoleName(role) {
  return window.localStorage.setItem(roleName, role)
}

export function removeRoleName() {
  return window.localStorage.removeItem(roleName)
}

export function getUserid() {
  return window.localStorage.getItem(UserID)
}

export function setUserid(userid) {
  return window.localStorage.setItem(UserID, userid)
}

export function removeUserid() {
  return window.localStorage.removeItem(UserID)
}